var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDowBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3364 8.6361C11.6883 8.2842 11.6883 7.7154 11.3364 7.36351C11.1609 7.188 10.9305 7.0998 10.7001 7.0998C10.4697 7.0998 10.2393 7.188 10.0638 7.36351L8.90005 8.52721V1.6998C8.90005 1.203 8.49775 0.799805 8.00005 0.799805C7.50235 0.799805 7.10005 1.203 7.10005 1.6998V8.52721L5.93635 7.36351C5.58445 7.01161 5.01565 7.01161 4.66375 7.36351C4.31185 7.7154 4.31185 8.2842 4.66375 8.6361L7.36375 11.3361C7.71565 11.688 8.28445 11.688 8.63635 11.3361L11.3364 8.6361Z",
    fill: "#3F76E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70005 13.4C1.20299 13.4 0.800049 13.803 0.800049 14.3C0.800049 14.7971 1.20299 15.2 1.70005 15.2H14.3C14.7971 15.2 15.2 14.7971 15.2 14.3C15.2 13.803 14.7971 13.4 14.3 13.4H1.70005Z",
    fill: "#3F76E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowBtn);
export default __webpack_public_path__ + "static/media/dowBtn.e24984a532c9a59da0d0a5ceb597316d.svg";
export { ForwardRef as ReactComponent };